<script lang="ts">
    import type {Loan, Seeking} from 'typings/portaro.be.types';
    import {getLocalization} from 'core/svelte-context/context';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import {states} from 'shared/constants/portaro.constants';
    import KpClassicTable from 'shared/ui-widgets/table/classic/KpClassicTable.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import {fade} from 'svelte/transition';
    import type {PageableList, PageableListState} from 'shared/utils/reactive-pageable-list';
    import type {EmptyObject} from 'typings/portaro.fe.types';
    import type {Observable} from 'rxjs';

    export let loanList: PageableList<Loan | Seeking, string, EmptyObject>;

    const localize = getLocalization();

    let loanListData: Observable<PageableListState<Loan | Seeking, string, EmptyObject>>;
    $: loanListData = loanList.getState$();

    $: loading = $loanListData.currentState === states.PROCESSING;
    $: noItems = !$loanListData.isPartiallyLoaded || $loanListData.loadedSize === 0;
    $: loadMore = !$loanListData.isAllLoaded && !loading;
</script>

{#if !loading || !noItems}
    <div in:fade>
        <KpClassicTable additionalClasses="kp-user-loans-table"
                        responsive
                        horizontallyDivided
                        hoverRows
                        stripedRows
                        colorAccented
                        columnHeadersCentered>

            <slot name="header" slot="header"/>
            <slot name="body" slot="body"/>
        </KpClassicTable>
    </div>
{/if}

{#if loading || noItems || loadMore}
    <div class="under-table-content" class:top-divider={!noItems}>
        {#if loading}
            <div class="loader-container">
                <KpLoadingBlock size="xs"/>
            </div>
        {/if}

        {#if noItems && !loading}
            <div class="panel-body text-muted text-center">
                {localize(/* @kp-localization commons.ZadnePolozky */ 'commons.ZadnePolozky')}
            </div>
        {/if}

        {#if loadMore}
            <div class="load-more-button-container">
                <KpButton on:click={() => loanList.loadNextPage()}
                          additionalClasses="load-more-button">
                    <IconedContent icon="search">
                        {localize(/* @kp-localization vysledky.NacistDalsi */ 'vysledky.NacistDalsi')}
                    </IconedContent>
                </KpButton>
            </div>
        {/if}
    </div>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    @table-header-footer-height: 54px;

    :global {
        .kp-user-loans-table {
            font-size: 13px;

            tr > th,
            tr > td {
                padding: @padding-large-vertical @padding-base-horizontal !important;
            }

            tr > th {
                height: @table-header-footer-height;
            }

            .centered-loan-data {
                text-align: center;
                vertical-align: middle;

                &.error-warning {
                    font-weight: 500;
                    color: var(--danger-red);
                }
            }
        }
    }

    .under-table-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: @padding-large-vertical;
        height: @table-header-footer-height;

        &.top-divider {
            border-top: 1px solid @table-border-color;
        }

        .loader-container {
            margin-top: 4px;
        }

        .load-more-button-container {
            width: 50%;
        }
    }

    :global {
        .load-more-button-container .load-more-button {
            width: 100%;
        }
    }
</style>